import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  useTheme,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CardActions,
  Avatar,
  Divider,
  TextField,
  OutlinedInput,
} from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import AssistantIcon from "@mui/icons-material/Assistant";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import { DataGrid } from "@mui/x-data-grid";
import DataGridCustomToolbar, {
  DataGridCustomToolbarClientMode,
} from "components/DataGridCustomToolbar";
import { ClearOutlined, CloseOutlined } from "@mui/icons-material";
import LinearProgress from "@mui/material/LinearProgress";
import { GetRouteList, GetRouteListByStation } from "api/routes";
import {
  DeletePackage,
  GetMatchPackageList,
  GetMatchPackageListByCustomer,
  matchPackage,
  PatchMatchPackage,
  scanPackage,
} from "api/packages";
import Swal from "sweetalert2";
import {
  getScanText,
  playAlertSound,
  playBabySneezeSound,
  playCorrectSound,
  playIncorrectSound,
} from "utils";
import { isMobile } from "react-device-detect";
import FlexBetween from "components/FlexBetween";
import moment from "moment";
import { GetAgentList } from "api/agent";
import Header from "components/Header";
import { GetFinalStationList, GetStationDetailById } from "api/stations";
import { defaultStation, user } from "localStorage";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MatchPackage = () => {
  const theme = useTheme();

  // values to be sent to the backend
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [sort, setSort] = useState({});
  const [search, setSearch] = useState("");
  // const [searchForMatch, setSearchForMatch] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Data to send to back-end
  const [tracking, setTracking] = useState("");
  // const [routeId, setRouteId] = useState("");
  const [customer, setCustomer] = useState(null);
  const [station, setStation] = useState("");
  const [orderId, setOrderId] = useState("");
  const [description, setDescription] = useState("");
  const [packageId, setPackageId] = useState("");

  // Data for front-end
  const [selectedStationForSearch, setSelectedStationForSearch] =
    useState(null);
  const [routeListForSearch, setRouteListForSearch] = useState([]);
  const [routeIdForSearch, setRouteIdForSearch] = useState("");
  const [stationListForSearch, setStationListForSearch] = useState([]);
  const [successCount, setSuccessCount] = useState(0);

  const _user = user();
  const _defaultStation = defaultStation();
  const isAgentUser = _user.role === "agent";

  // values to set in DataGrid
  const [rows, setRows] = useState([]);
  const [rowsForMatch, setRowsForMatch] = useState([]);

  // Value to set in DataGrid in Dialog
  const [filteredRows, setFilteredRows] = useState(null);
  const [filteredRowsForMatch, setFilteredRowsForMatch] = useState(null);

  const [editDialogOpen, setEditDialogOpen] = React.useState(false);

  function RefreshPackageList(station, route) {
    setIsLoading(true);
    GetMatchPackageList(station, route).then((res) => {
      if (res.status === 200) {
        setRows(res.data.packages);
      } else {
        setRows([]);
      }
      setIsLoading(false);
    });
  }

  const getPackageListForMatching = (customerId) => {
    GetMatchPackageListByCustomer(customerId).then((res) => {
      if (res.status === 200) {
        setRowsForMatch(res.data.packages);
      } else {
        setRowsForMatch([]);
        console.log(res.message);
      }
    });
  };

  function filterSearch(dataArr, searchValue) {
    if (dataArr) {
      let newArr = dataArr.slice();
      if (searchValue) {
        newArr = newArr.filter((element) => {
          return (
            (element.tracking &&
              element.tracking
                .toLowerCase()
                .includes(searchValue.toLowerCase())) ||
            (element.description &&
              element.description
                .toLowerCase()
                .includes(searchValue.toLowerCase())) ||
            (element.customer &&
              element.customer.name
                .toLowerCase()
                .includes(searchValue.toLowerCase())) ||
            (element.orderId &&
              element.orderId.toLowerCase().includes(searchValue.toLowerCase()))
          );
        });
      }

      setFilteredRows(newArr);
    }
  }

  function filterSearchForMatch(dataArr, searchValue) {
    // console.log("filterSearchForMatch", searchValue);
    if (dataArr) {
      let newArr = dataArr.slice();
      if (searchValue) {
        newArr = newArr.filter((element) => {
          return (
            (element.tracking &&
              element.tracking
                .toLowerCase()
                .includes(searchValue.toLowerCase())) ||
            (element.description &&
              element.description
                .toLowerCase()
                .includes(searchValue.toLowerCase())) ||
            (element.customer &&
              element.customer.name
                .toLowerCase()
                .includes(searchValue.toLowerCase())) ||
            (element.orderId &&
              element.orderId.toLowerCase().includes(searchValue.toLowerCase()))
          );
        });
      }

      setFilteredRowsForMatch(newArr);
    }
  }

  useEffect(() => {
    filterSearch(rows, search);
  }, [rows, search]);

  useEffect(() => {
    filterSearchForMatch(rowsForMatch, search);
  }, [rowsForMatch, search]);

  useEffect(() => {
    if (selectedStationForSearch) {
      GetRouteListByStation(selectedStationForSearch.id).then((res) => {
        if (res.status === 200 && res.data) {
          setRouteListForSearch(res.data);
          setRouteIdForSearch(res.data[0].id);
        }
      });
      RefreshPackageList(selectedStationForSearch.id, routeIdForSearch);
    }
  }, [selectedStationForSearch, routeIdForSearch, successCount]);

  useEffect(() => {
    setSelectedStationForSearch(_defaultStation);
    GetRouteList().then((res) => {
      setRouteListForSearch(res.data);
    });

    GetFinalStationList().then((res) => {
      if (res && res.status === 200) {
        setStationListForSearch(res.data);
        // let arr = res.data;
        // let validStation = [];
        // if (Array.isArray(arr)) {
        //   arr.forEach((finalStation) => {
        //     // console.log("finalStation", finalStation);
        //     _user.stations.forEach((userStation) => {
        //       // console.log("userStation", userStation);
        //       if (finalStation.id === userStation.id)
        //         validStation.push(finalStation);
        //     });
        //   });
        // }
        // if (validStation) setStationListForSearch(validStation);
      }
      setSelectedStationForSearch(_defaultStation);
    });
  }, []);

  const buttonFindPackageHandler = (packageItem) => {
    const { _id, tracking, customer, routeId, station } = packageItem;
    setPackageId(_id);
    setTracking(tracking);
    setRouteIdForSearch(routeId);
    setCustomer(customer);
    setStation(station);
    setEditDialogOpen(true);
    getPackageListForMatching(customer.id);
    setSearch("");
  };

  const buttonMatchHandler = (packageItem) => {
    playAlertSound();
    // const { _id, tracking, customer, routeId, station } = packageItem;
    Swal.fire({
      title: `Match ${tracking} with  ${packageItem.tracking} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, match it!",
    }).then((result) => {
      if (result.isConfirmed) {
        matchPackage(packageItem.tracking, tracking).then((res) => {
          if (res.status === 200) {
            setSuccessCount(successCount + 1);
            GetStationDetailById(station).then((res) => {
              if (res.status === 200 && res.data.finalStation) {
                playCorrectSound();
                Swal.fire({
                  icon: "success",
                  title: `${tracking}`,
                  text: `The package has been matched!`,
                  timer: 1500,
                });
                setEditDialogOpen(false);
                setSearch("");
              } else {
                scanPackageSubmited(tracking, selectedStationForSearch);
              }
            });
          } else if (res.status === 422) {
            playAlertSound();
            Swal.fire({
              title: res.data.status,
              icon: "warning",
              text: res.data.message,
              timer: 1200,
            });
          } else {
            playIncorrectSound();
            Swal.fire({
              title: res.data.status,
              icon: "error",
              text: res.data.message,
              timer: 1500,
            });
          }
        });
      }
    });
  };

  const scanPackageSubmited = (tracking, selectedStation) => {
    let actionType = "match-auto-scan"
    scanPackage(getScanText(tracking), selectedStation.id, actionType).then((res) => {
      if (res && res.status === 200) {
        if (
          selectedStation.id === "VTE" &&
          res.data.package &&
          res.data.package.routeId === "VTE-THK"
        ) {
          playBabySneezeSound(); // to indicate that the scanned item need to be sent to THK branch
        } else {
          playCorrectSound(); // to indicate that the scanned item need to be sent to PHT branch
        }
        Swal.fire({
          icon: "success",
          title: `${tracking}`,
          text: `The package is matched and the automatic scan is complete!`,
          timer: 1500,
        });
        setEditDialogOpen(false);
        setSearch("");
      } else if (res.status === 202) {
        console.log(selectedStation);
        if (!selectedStation.isSortStation) {
          playIncorrectSound();
          Swal.fire({
            title: res.data.status,
            icon: "warning",
            text: res.data.message,
            timer: 2000,
          });
          return;
        }
      } else {
        playIncorrectSound();
        Swal.fire({
          title: res.data.status,
          icon: "error",
          text: res.data.message,
          timer: 2000,
        });
      }
    });
  };

  const buttonDeleteHandler = (event, cellValues) => {
    console.log("delete button clicked");
    Swal.fire({
      title: `Delete ${cellValues.row.tracking} ?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        DeletePackage(cellValues.row._id).then((res) => {
          if (res.status === 200) {
            // DELETE SELECTED ROW FROM ARRAY "data.packages"
            setRows(() => {
              return rows.filter((item) => item._id !== cellValues.id);
            });
            playCorrectSound();
            Swal.fire({
              title: "Deleted!",
              text: res.message,
              icon: "success",
              timer: 1500,
            });
          } else if (res.status === 400) {
            playAlertSound();
            Swal.fire({
              backdrop: true,
              toast: false,
              icon: "error",
              text: `Status ${res.status} - ${res.data.message}`,
              showConfirmButton: true,
            });
          } else {
            playIncorrectSound();
            Swal.fire({
              backdrop: true,
              toast: false,
              icon: "error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        });
      }
    });
  };

  const buttonSubmitHandler = () => {
    if (orderId.trim() === "" || description.trim() === "") {
      playAlertSound();
      Swal.fire({
        backdrop: true,
        toast: false,
        title: "ຂໍ້ມູນບໍ່ຄົບຖ້ວນ",
        icon: "error",
        text: `ກະລຸນາລະບຸເລກທີຄຳສັ່ງຊຶ້ ແລະ ລາຍລະອຽດພັດສະດຸໃຫ້ຄົບຖ້ວນ`,
        showConfirmButton: true,
      });
      return;
    }

    PatchMatchPackage(packageId, tracking, orderId, description).then((res) => {
      if (res && res.status === 200) {
        setDescription("");
        setOrderId("");
        setSuccessCount(successCount + 1);
        scanPackageSubmited(tracking, selectedStationForSearch);
      } else if (res && res.status === 422) {
        playAlertSound();
        Swal.fire({
          title: res.data.status,
          icon: "warning",
          text: res.data.message,
          timer: 1200,
        });
      } else {
        playIncorrectSound();
        Swal.fire({
          title: res.data.status,
          icon: "error",
          text: res.data.message,
          timer: 1500,
        });
      }
    });
  };

  const columns = [
    {
      field: "_id",
      headerName: "ID",
      flex: 1,
      hide: true,
    },
    {
      field: "edit",
      headerName: "Find",
      flex: 0.2,
      renderCell: (cellValues) => {
        return (
          <IconButton
            variant="outline"
            onClick={() => {
              buttonFindPackageHandler(cellValues.row);
            }}
            sx={{ "&:hover": { color: theme.palette.warning.main } }}
          >
            <ContentPasteSearchIcon />
          </IconButton>
        );
      },
    },
    {
      field: "customer",
      headerName: "Customer",
      flex: 0.5,
      valueGetter: (params) => params.row.customer && params.row.customer.name,
    },
    {
      field: "tracking",
      headerName: "Tracking",
      flex: 0.5,
    },
    {
      field: "orderId",
      headerName: "Order ID",
      flex: 0.5,
      hide: isMobile,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
    },
    {
      field: "routeId",
      headerName: "Route ID",
      flex: 0.5,
      hide: isMobile,
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 0.3,
      hide: true,
    },
    // {
    //   field: "quantity",
    //   headerName: "QTY",
    //   flex: 0.5,
    // },

    {
      field: "status",
      headerName: "Status",
      flex: 0.3,
      hide: true,
    },
    {
      field: "station",
      headerName: "Station",
      flex: 0.3,
      hide: isMobile,
    },
    {
      field: "isCOD",
      headerName: "COD",
      flex: 0.3,
      hide: isMobile,
      renderCell: (cellValues) => {
        return cellValues.row.isCOD ? (
          <CheckBoxIcon color="secondary" />
        ) : (
          <DoNotDisturbIcon color="primary" />
        );
      },
    },
    {
      field: "shippingFee",
      headerName: "ຄ່າບໍລິການ",
      flex: 0.3,
    },
    {
      field: "finalShippingFee",
      headerName: "Final Fee",
      flex: 0.3,
      hide: isMobile,
    },
    {
      field: "isForwardRequired",
      headerName: "ສົ່ງຕໍ່",
      flex: 0.3,
      hide: isMobile,
      renderCell: (cellValues) => {
        return cellValues.row.isForwardRequired ? (
          <CheckBoxIcon color="secondary" />
        ) : (
          <DoNotDisturbIcon color="primary" />
        );
      },
    },
    {
      field: "isDeliveryRequired",
      headerName: "ສົ່ງຢູ່ບ້ານ",
      flex: 0.3,
      hide: isMobile,
      renderCell: (cellValues) => {
        return cellValues.row.isDeliveryRequired ? (
          <CheckBoxIcon color="secondary" />
        ) : (
          <DoNotDisturbIcon color="primary" />
        );
      },
    },
    {
      field: "isSelfOrder",
      headerName: "ສັ່ງເອງ",
      flex: 0.3,
      hide: isMobile,
      renderCell: (cellValues) => {
        return cellValues.row.isSelfOrder ? (
          <CheckBoxIcon color="secondary" />
        ) : (
          <DoNotDisturbIcon color="primary" />
        );
      },
    },
    {
      field: "isSubCustomer",
      headerName: "ລູກຄ້າຕົວແທນ",
      flex: 0.3,
      hide: isMobile || isAgentUser,
      renderCell: (cellValues) => {
        return cellValues.row.isSubCustomer ? (
          <CheckBoxIcon color="secondary" />
        ) : (
          <DoNotDisturbIcon color="primary" />
        );
      },
    },
    {
      field: "agentId",
      headerName: "ຕົວແທນ",
      flex: 0.3,
      hide: isMobile || isAgentUser,
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      flex: 0.7,
      hide: isMobile,
      valueGetter: (params) =>
        moment(params.row.updatedAt)
          .tz("Asia/Vientiane")
          .format("DD/MM/YYYY, h:mm:ss A"),
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 0.7,
      hide: true,
      valueGetter: (params) =>
        moment(params.row.createdAt)
          .tz("Asia/Vientiane")
          .format("DD/MM/YYYY, h:mm:ss A"),
    },
    {
      field: "del",
      headerName: "Delete",
      flex: 0.2,
      hide: true,
      renderCell: (cellValues) => {
        return (
          <IconButton
            variant="outline"
            sx={{ "&:hover": { color: theme.palette.error.main } }}
            onClick={(event) => buttonDeleteHandler(event, cellValues)}
          >
            <ClearOutlined />
          </IconButton>
        );
      },
    },
  ];

  const matchColumns = [
    {
      field: "_id",
      headerName: "ID",
      flex: 1,
      hide: true,
    },
    {
      field: "edit",
      headerName: "Match",
      flex: 0.2,
      renderCell: (cellValues) => {
        return (
          <IconButton
            variant="outline"
            onClick={() => {
              buttonMatchHandler(cellValues.row);
            }}
            sx={{ "&:hover": { color: theme.palette.warning.main } }}
          >
            <AssistantIcon />
          </IconButton>
        );
      },
    },
    {
      field: "customer",
      headerName: "Customer",
      flex: 0.5,
      valueGetter: (params) => params.row.customer && params.row.customer.name,
    },
    {
      field: "tracking",
      headerName: "Tracking",
      flex: 0.5,
    },
    {
      field: "orderId",
      headerName: "Order ID",
      flex: 0.5,
      hide: isMobile,
    },
    {
      field: "description",
      headerName: "Description",
      flex: 1,
    },
    {
      field: "routeId",
      headerName: "Route ID",
      flex: 0.5,
      hide: isMobile,
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 0.3,
      hide: true,
    },
    // {
    //   field: "quantity",
    //   headerName: "QTY",
    //   flex: 0.5,
    // },

    {
      field: "status",
      headerName: "Status",
      flex: 0.3,
      hide: true,
    },
    {
      field: "station",
      headerName: "Station",
      flex: 0.3,
      hide: isMobile,
    },
    {
      field: "isCOD",
      headerName: "COD",
      flex: 0.3,
      hide: isMobile,
      renderCell: (cellValues) => {
        return cellValues.row.isCOD ? (
          <CheckBoxIcon color="secondary" />
        ) : (
          <DoNotDisturbIcon color="primary" />
        );
      },
    },
    {
      field: "shippingFee",
      headerName: "ຄ່າບໍລິການ",
      flex: 0.3,
    },
    {
      field: "isForwardRequired",
      headerName: "ສົ່ງຕໍ່",
      flex: 0.3,
      hide: isMobile,
      renderCell: (cellValues) => {
        return cellValues.row.isForwardRequired ? (
          <CheckBoxIcon color="secondary" />
        ) : (
          <DoNotDisturbIcon color="primary" />
        );
      },
    },
    {
      field: "isDeliveryRequired",
      headerName: "ສົ່ງຢູ່ບ້ານ",
      flex: 0.3,
      hide: isMobile,
      renderCell: (cellValues) => {
        return cellValues.row.isDeliveryRequired ? (
          <CheckBoxIcon color="secondary" />
        ) : (
          <DoNotDisturbIcon color="primary" />
        );
      },
    },
    {
      field: "isSelfOrder",
      headerName: "ສັ່ງເອງ",
      flex: 0.3,
      hide: isMobile,
      renderCell: (cellValues) => {
        return cellValues.row.isSelfOrder ? (
          <CheckBoxIcon color="secondary" />
        ) : (
          <DoNotDisturbIcon color="primary" />
        );
      },
    },
    {
      field: "isSubCustomer",
      headerName: "ລູກຄ້າຕົວແທນ",
      flex: 0.3,
      hide: isMobile,
      renderCell: (cellValues) => {
        return cellValues.row.isSubCustomer ? (
          <CheckBoxIcon color="secondary" />
        ) : (
          <DoNotDisturbIcon color="primary" />
        );
      },
    },
    {
      field: "agentId",
      headerName: "ຕົວແທນ",
      flex: 0.3,
      hide: isMobile,
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      flex: 0.7,
      hide: isMobile,
      valueGetter: (params) =>
        moment(params.row.updatedAt)
          .tz("Asia/Vientiane")
          .format("DD/MM/YYYY, h:mm:ss A"),
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 0.7,
      hide: true,
      valueGetter: (params) =>
        moment(params.row.createdAt)
          .tz("Asia/Vientiane")
          .format("DD/MM/YYYY, h:mm:ss A"),
    },
  ];

  return (
    <Box m={isMobile ? "0 0.5rem" : "0 1rem"}>
      <Grid container spacing={1}>
        <Grid mb={1} item xl={12} md={12} xs={12}>
          <Header
            title="Match Package"
            subtitle="ຈັບຄູ່ພັດສະດຸ ສຳຫຼັບແພັກເກດທີ່ເລກພັດສະດຸບໍ່ຕົງກັນກັບຕົວຈິງ"
          />
        </Grid>
        <Grid item xl={6} md={6} xs={12}>
          <FlexBetween>
            {/* Scan package section */}
            <Grid container spacing={2}>
              <Grid item xl={6} md={6} xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Select station</InputLabel>
                  <Select
                    label="Select station"
                    value={
                      selectedStationForSearch
                        ? selectedStationForSearch.id
                        : ""
                    }
                    onChange={(e) => {
                      GetStationDetailById(e.target.value).then((res) => {
                        if (res.status === 200) {
                          setSelectedStationForSearch(res.data);
                        }
                      });
                    }}
                    required
                  >
                    {stationListForSearch &&
                      stationListForSearch.map(({ id, name }) => {
                        return (
                          <MenuItem key={id} value={id}>
                            {id} ({name})
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xl={6} md={6} xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Route</InputLabel>
                  <Select
                    id="route"
                    value={!routeIdForSearch ? "" : routeIdForSearch}
                    label="Route"
                    onChange={(event) =>
                      setRouteIdForSearch(event.target.value)
                    }
                    required
                  >
                    {routeListForSearch &&
                      routeListForSearch.map(({ id, name }) => {
                        return (
                          <MenuItem key={id} value={id}>
                            {id} ({name})
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </FlexBetween>
        </Grid>
        <Grid item xl={12} md={12} xs={12}>
          <Divider />
        </Grid>
        <Grid mt={"-0.5rem"} item xl={12} md={12} xs={12}>
          {isLoading ? (
            <Box sx={{ width: "100%" }}>
              <LinearProgress color="secondary" />
            </Box>
          ) : (
            ""
          )}
          <Box
            height="75vh"
            sx={{
              "& .MuiDataGrid-root": {
                border: "none",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "none",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: theme.palette.background.alt,
                color: theme.palette.secondary[100],
                borderBottom: "none",
              },
              "& .MuiDataGrid-virtualScroller": {
                backgroundColor: theme.palette.primary.light,
              },
              "& .MuiDataGrid-footerContainer": {
                backgroundColor: theme.palette.background.alt,
                color: theme.palette.secondary[100],
                borderTop: "none",
              },
              "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                color: `${theme.palette.secondary[200]} !important`,
              },
            }}
          >
            <DataGrid
              loading={isLoading}
              getRowId={(row) => row._id}
              rows={filteredRows || []}
              columns={columns}
              rowCount={filteredRows ? filteredRows.length : 0}
              rowsPerPageOptions={[20, 50, 100]}
              pagination
              page={page}
              pageSize={pageSize}
              paginationMode="client"
              sortingMode="client"
              filterMode="client"
              onPageChange={(newPage) => setPage(newPage)}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              // onSortModelChange={(newSortModel) => setSort(...newSortModel)}
              components={{ Toolbar: DataGridCustomToolbarClientMode }}
              componentsProps={{
                toolbar: { search, setSearch },
              }}
            />
          </Box>
        </Grid>
      </Grid>

      {/* Edit Package Dialog  */}
      <Box>
        <Dialog
          open={editDialogOpen}
          TransitionComponent={Transition}
          maxWidth="xl"
          fullScreen={true}
          keepMounted
          onClose={() => {
            setSearch("");
            setEditDialogOpen(false);
          }}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>
            <Typography
              color={theme.palette.secondary[200]}
              // fontWeight="bold"
              sx={{ mb: 1 }}
            >
              Match Package
            </Typography>
            <IconButton
              aria-label="close"
              onClick={() => {
                setSearch("");
                setEditDialogOpen(false);
              }}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseOutlined />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xl={12} md={12} xs={12}>
                <Divider />
              </Grid>
              <Grid item xl={6} md={9} xs={12}>
                <Grid container spacing={1}>
                  <Grid item xl={3} md={3} xs={6}>
                    <Typography>Tracking number: </Typography>
                    <Typography
                      variant="h4"
                      color={theme.palette.secondary[200]}
                      fontWeight="bold"
                      sx={{ mb: 1 }}
                    >
                      {tracking}
                    </Typography>
                  </Grid>
                  <Grid item xl={3} md={3} xs={6}>
                    <Typography>Customer: </Typography>
                    <Typography
                      variant="h4"
                      color={theme.palette.secondary[200]}
                      fontWeight="bold"
                      sx={{ mb: 1 }}
                    >
                      {customer && `${customer.name} - ${customer.whatsapp}`}
                    </Typography>
                  </Grid>
                  <Grid item xl={3} md={3} xs={6}>
                    <Typography>Station: </Typography>
                    <Typography
                      variant="h4"
                      color={theme.palette.secondary[200]}
                      fontWeight="bold"
                      sx={{ mb: 1 }}
                    >
                      {station}
                    </Typography>
                  </Grid>
                  <Grid item xl={3} md={3} xs={6}>
                    <Typography>Route: </Typography>
                    <Typography
                      variant="h4"
                      color={theme.palette.secondary[200]}
                      fontWeight="bold"
                      sx={{ mb: 1 }}
                    >
                      {routeIdForSearch}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xl={12} md={12} xs={12}>
                <Grid container spacing={1}>
                  <Grid item xl={3} md={3} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel>Order ID</InputLabel>
                      <OutlinedInput
                        type="text"
                        label="Order ID"
                        value={orderId}
                        id="orderId"
                        onChange={(e) => setOrderId(e.target.value)}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xl={7} md={7} xs={12}>
                    <FormControl fullWidth>
                      <TextField
                        multiline
                        maxRows={5}
                        minRows={1}
                        label="Description"
                        value={description}
                        id="decscription"
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xl={2} md={2} xs={2}>
                    <FormControl fullWidth sx={{ height: "100%" }}>
                      <Button
                        variant="contained"
                        color="secondary"
                        type="submit"
                        size="large"
                        sx={{ height: "100%" }}
                        disabled={orderId === "" || description === ""}
                        onClick={() => buttonSubmitHandler()}
                      >
                        Submit
                      </Button>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xl={12} md={12} xs={12}>
                <Box
                  height="70vh"
                  sx={{
                    "& .MuiDataGrid-root": {
                      border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      borderBottom: "none",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: theme.palette.background.alt,
                      color: theme.palette.secondary[100],
                      borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      backgroundColor: theme.palette.primary.light,
                    },
                    "& .MuiDataGrid-footerContainer": {
                      backgroundColor: theme.palette.background.alt,
                      color: theme.palette.secondary[100],
                      borderTop: "none",
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                      color: `${theme.palette.secondary[200]} !important`,
                    },
                    marginLeft: isMobile ? "-1rem" : "0",
                    marginRight: isMobile ? "-1rem" : "0",
                  }}
                >
                  <DataGrid
                    // loading={isLoading}
                    getRowId={(row) => row._id}
                    rows={filteredRowsForMatch || []}
                    columns={matchColumns}
                    rowCount={
                      filteredRowsForMatch ? filteredRowsForMatch.length : 0
                    }
                    rowsPerPageOptions={[20, 50, 100]}
                    pagination
                    page={page}
                    pageSize={pageSize}
                    paginationMode="client"
                    sortingMode="client"
                    filterMode="client"
                    onPageChange={(newPage) => setPage(newPage)}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    // onSortModelChange={(newSortModel) => setSort(...newSortModel)}
                    components={{ Toolbar: DataGridCustomToolbarClientMode }}
                    componentsProps={{
                      toolbar: { search, setSearch },
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </Box>
    </Box>
  );
};

export default MatchPackage;
